import { usePostOauth } from '@/api/auth'
import pagePath from '@/utils/pagePath'
import { useToastPopup } from '@collable/ui'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'

const ChannelVerifyRedirectPage = () => {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const scope = searchParams.get('scope')
  const { mutate: postOauth } = usePostOauth()
  const navigate = useNavigate()
  const { addToastPopup } = useToastPopup()

  useEffect(() => {
    if (code && scope) {
      postOauth(
        { code, scope, redirectUri: import.meta.env.VITE_GOOGLE_VERIFY_REDIRECT_URL },
        {
          onSuccess: () => {
            addToastPopup({
              type: 'normal',
              message: '승인 요청 완료',
              status: 'positive',
            })
            navigate(pagePath.channelVideos('temp-email'))
          },
        },
      )
    }
  }, [addToastPopup, code, navigate, postOauth, scope])

  return null
}

export default ChannelVerifyRedirectPage
